export const PERMISSIONS = {
  USERS: "USERS",
  USERS_CREATE: "USERS_CREATE",
  USERS_EDIT: "USERS_EDIT",
  USERS_DELETE: "USERS_DELETE",
  USERS_ROLE: "USERS_ROLE",
  USERS_SET_PROFILE: "USERS_SET_PROFILE",
  USERS_REMOVE_PROFILE: "USERS_REMOVE_PROFILE",
  USERS_REVOKE: "USERS_REVOKE",
  USERS_CHANGE_ROLE: "USERS_CHANGE_ROLE",
  USERS_CREATE_IT_ADMIN: "USERS_CREATE_IT_ADMIN",
  ORGANIZATION: "ORGANIZATION",
  ORGANIZATION_CREATE: "ORGANIZATION_CREATE",
  ORGANIZATION_EDIT: "ORGANIZATION_EDIT",
  ORGANIZATION_ADD_USER: "ORGANIZATION_ADD_USER",
  ORGANIZATION_REMOVE_USER: "ORGANIZATION_REMOVE_USER",
  ORGANIZATION_SET_LOGO: "ORGANIZATION_SET_LOGO",
  ORGANIZATION_REMOVE_LOGO: "ORGANIZATION_REMOVE_LOGO",
  ORGANIZATION_DEVICE_LOG: "ORGANIZATION_DEVICE_LOG",
  ORGANIZATION_AUDIT_LOG: "ORGANIZATION_AUDIT_LOG",
  ORGANIZATION_LOGIN: "ORGANIZATION_LOGIN",
  ORGANIZATION_REMOVE: "ORGANIZATION_REMOVE",
  DEVICES: "DEVICES",
  DEVICES_EDIT: "DEVICES_EDIT",
  MFA_STATUSES: "MFA_STATUSES",
  MFA_ENABLED_METHODS: "MFA_ENABLED_METHODS",
  ACL_UPDATE_CUSTOM_ROLE: "ACL_UPDATE_CUSTOM_ROLE",
  ACL_GET_PERMISSIONS_OF_ROLE: "ACL_GET_PERMISSIONS_OF_ROLE",
  ACL_CREATE_CUSTOM_ROLE: "ACL_CREATE_CUSTOM_ROLE",
  BILLING_READ: "BILLING_READ",
  BILLING_CHECKOUT: "BILLING_CHECKOUT",
  BILLING_UPGRADE_PLAN: "BILLING_UPGRADE_PLAN",
  BILLING_CANCEL_SUBSCRIPTION: "BILLING_CANCEL_SUBSCRIPTION",
} as const;

export type PermissionName = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
